
const $ = require('jquery');


    window.addEventListener('load', function (event) {
        var $input1 = document.querySelector('#een-zin');
        if (!$input1) { return; }
        var $input2 = document.querySelector('#twee-zinnen');
        if (!$input2) { return; }
        var $div = document.querySelector('#zin-twee');
        if (!$div) { return; }
        $input1.addEventListener('change', function () {
            $div.style.display = this.value === 'een' ? 'none' : '';
        });
        $input2.addEventListener('change', function () {
            $div.style.display = this.value === 'twee' ? '' : 'none';
        });
    });

const productDetail = () => {

	$('.js-set-name-number').on('change', function() {
		const selected = $('option:selected',this);
		if (selected && selected.length > 0 && $(this).val()){
			const nr = $(this).val();
			const name = selected.data('player-name');
			const image = selected.data('player-image');

			$('.js-name-input').val(name);
			$('.js-number-input').val(nr);
			if (image && image != '') {
				$('.gallery-navigation .gallery-item').removeClass('is-active');
				$('.gallery-display img').attr('src', image);
			}

			// set floating label state
			$('.js-name-input, .js-number-input')
			.closest('.js-float-label')
			.addClass('is-active');

			// force embellishment trigger
			if (document.querySelector('.js-change-text')) document.querySelector('.js-change-text').dispatchEvent(new Event('input'));
			if (document.querySelector('.js-change-number')) document.querySelector('.js-change-number').dispatchEvent(new Event('input'));
			
			$(this).trigger('focus');
			$(this).val('');
			$('.js-name-input').trigger('change');
		}
	});

	$('.js-set-name-number').trigger('change');

	$('.js-name-input, .js-number-input, .js-addon-item').on('change', function() {
		const name = $('.js-name-input');
		const number = $('.js-number-input');
		const checkedItems = $('.js-addon-item:checked');
		const priceLabel = $('.js-price-label');
		priceLabel.each(function() {
			const lbl = $(this);
			let price = parseFloat(lbl.data('price'));
			if (name.val()) {
				price += parseFloat(name.data('price'));
			}
			if (number.val()) {
				price += parseFloat(number.data('price'));
			}
			for (let i = 0; i < checkedItems.length; i++) {
				price += parseFloat($(checkedItems[i]).data('price'));
			}

			const whole = Math.floor(price);
			let fraction = Math.round((price - whole) * 100.0);
			fraction = String("0" + fraction).slice(-2);
			if (fraction == 0) fraction = "-";
			lbl.html("&euro;&nbsp;" + whole + "," + fraction);
		});
	});
	$('.js-name-input').trigger('change');
};

module.exports = productDetail;
